export default {
  promoInfo: '活动信息汇总',
  shop: '按商城查询',
  brand: '按品牌查询',
  promoHistory: '活动信息导出表格',
};
